import React, { Fragment } from 'react';
import incident1 from '../../../../images/incident1.png';
import support from '../../../../images/supportticket.png';

const DriverAccident = () => (
  <Fragment>
    <Fragment>
      <p>Please follow the steps below:</p>
      <ol>
        <li>
          Check for injuries - if anyone is injured, call 911 immediately.
        </li>
        <li>
          On your dashboard, scroll down to the quick links to select
          “Insurance slip” to view the insurance page.
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              If you were online during the time of the accident, select
              “View Insurance Slip” for instructions on how to retrieve the
              insurance information from the Uber Driver app.
            </li>
            <li>
              If you were offline during the time of the accident, select
              “No, I was offline” to retrieve Autzu’s insurance
              information.
            </li>
          </ol>
        </li>
        <li>
          Exchange personal and vehicle information with third parties
          (other drivers involved in the accident).
        </li>
        <li>
          Create an accident report: On the navigation bar, select Support
          > New Support > Accident Report and make sure to attach all
          accident detail and photos, including:
          <ol style={{ listStyleType: 'lower-alpha' }}>
            <li>
              <strong>Exact time of accident,</strong>
            </li>
            <li>
              <strong>Address or location of accident,</strong>
            </li>
            <li>
              <strong>
                Were you “online” or “offline” a rideshare driver app at
                the time of the accident?
              </strong>
            </li>
            <li>
              <strong>
                A short description of what happened and finally,
              </strong>
            </li>
            <li>
              <strong>
                Photos of all vehicles involved, and focused photos of the
                damaged area(s).
              </strong>
            </li>
          </ol>
        </li>
        <li>
          If the Autzu vehicle is driveable, drive back to the Autzu
          parking hub.
        </li>
        <li>
          If the Autzu vehicle is not driveable, contact Autzu support in
          the live chat so we can help arrange roadside assistance.
        </li>
        <li>
          Stay with the vehicle until the authorized tow truck arrives at
          your location and the vehicle will be taken to one of our
          approved repair vendors.
        </li>
      </ol>
      <p>
        We will contact you within 1-2 days to confirm the accident details
        and discuss the insurance claim process and insurance deductible
        with you.
      </p>
      <h4 className="subtitle">How to create a support ticket?</h4>
      <ol>
        <li>
          Open the Autzu app and select Support on the navigation bar.
        </li>
        <li>
          Tap “New support” and fill in the required information then press
          next We will be sure to respond to you as soon as possible.
        </li>
      </ol>
      <br />
      <div style={{ textAlign: 'center' }}>
        <img src={support} style={{ width: '200px', height: '455px' }} />
      </div>
    </Fragment>
  </Fragment>
);

export default DriverAccident;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/AccidentsAndInsurance/DriverAccident.js